// extracted by mini-css-extract-plugin
export default {"containerSearch":"styles_containerSearch__S6KuI","header":"styles_header__jV08O","actions":"styles_actions__2Lt2B","tasks":"styles_tasks__BqyoQ"};